import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropzone", "input", "primary"]

  connect() {
    this.dropzoneTarget.addEventListener("dragover", this.onDragOver)
    this.dropzoneTarget.addEventListener("dragleave", this.onDragLeave)
    this.dropzoneTarget.addEventListener("drop", this.onDrop)
  }

  disconnect() {
    this.dropzoneTarget.removeEventListener("dragover", this.onDragOver)
    this.dropzoneTarget.removeEventListener("dragleave", this.onDragLeave)
    this.dropzoneTarget.removeEventListener("drop", this.onDrop)
  }

  onDragOver = (event) => {
    event.preventDefault()
    this.dropzoneTarget.classList.add("is-over")
  }

  onDragLeave = () => {
    this.dropzoneTarget.classList.remove("is-over")
  }

  onDrop = (event) => {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("is-over")
    const file = event.dataTransfer.files[0]
    if (!file) return
    const dt = new DataTransfer()
    dt.items.add(file)
    this.inputTarget.files = dt.files
    this.updateFilename(file.name)
  }

  pick() {
    const file = this.inputTarget.files[0]
    if (file) this.updateFilename(file.name)
  }

  updateFilename(name) {
    if (this.hasPrimaryTarget) {
      this.primaryTarget.textContent = name
    }
    this.dropzoneTarget.classList.add("is-filled")
  }
}
